import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import About from "./components/About";
import Projects from "./components/Projects";
import Footer from "./components/Footer";

import Volunteer from "./pages/Volunteer";
import Donate from "./pages/Donate";
import Contact from "./pages/Contact";
import Essay from "./pages/Essay";
import Winners from "./pages/Winners"; 
import Articles from "./pages/Articles";
import EssayDetail from "./pages/EssayDetail";

import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function App() {

  useEffect(()=>{
    AOS.init({
      duration:1000,
      once:true
    });
  },[]);
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Stats />
              <About />
              <Projects />
            </>
          }
        />


        <Route path="/volunteer" element={<Volunteer />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/essay" element={<Essay />} />
        <Route path="/winners" element={<Winners />} />
        <Route path="/articles" element={<Articles />} />
         <Route path="/essay/:id" element={<EssayDetail />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
